import {
  LkUser as Data,
  LkUserCollection as Collection,
} from '@/typings/api/User'
import {
  BaseApiParams,
  BaseApiResponse,
  BaseApiResponseCollection,
} from '@/typings/common'

import { BaseLkApiAuth } from '@/api/BaseApiAuth'


type BRC = BaseApiResponseCollection<never> & {
  data: Data;
}

export class LkUsersApi extends BaseLkApiAuth<
  Data,
  Collection,
  BaseApiParams,
  BaseApiResponse<Data>,
  BRC
  > {
  protected readonly endpoint = 'users';

  public current(params?: Record<string, unknown>, config = {}) {
    const path = 'current'
    const [url] = this.getUrl(path, params)
    const config_n = { params, ...config }
    type IResponse = { data: Data }
    return this.request<null, IResponse>('GET', url, config_n)
  }

  public permissions(params?: Record<string, unknown>, config = {}) {
    const path = 'current/permissions'
    const [url] = this.getUrl(path, params)
    const config_n = { params, ...config }
    type IResponse = { data: Data }
    return this.request<null, IResponse>('GET', url, config_n)
  }
}
